(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[398],{

/***/ 99352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/index.js
var react = __webpack_require__(49053);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(19915);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(82148);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(99603);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(95268);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/lodash/lodash.js
var lodash = __webpack_require__(24822);
// EXTERNAL MODULE: ../../libs/web-ui/src/components/icon/icon.tsx
var icon = __webpack_require__(1486);
// EXTERNAL MODULE: ../../libs/feature-flags/src/index.ts
var src = __webpack_require__(2298);
// EXTERNAL MODULE: ../../libs/analytics/src/index.ts + 2 modules
var analytics_src = __webpack_require__(98029);
// EXTERNAL MODULE: ../../libs/utils/src/index.ts + 64 modules
var utils_src = __webpack_require__(40418);
// EXTERNAL MODULE: ../../libs/feature-fantasy/src/lib/progress-pane/progress-pane.web.tsx + 1 modules
var progress_pane_web = __webpack_require__(53656);
// EXTERNAL MODULE: ../../libs/schema/src/index.ts
var schema_src = __webpack_require__(17565);
// EXTERNAL MODULE: ../../libs/data-provider/src/index.ts + 18 modules
var data_provider_src = __webpack_require__(77307);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/router.js
var next_router = __webpack_require__(35888);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(70144);
// EXTERNAL MODULE: ./components/common/button/button.tsx + 1 modules
var button_button = __webpack_require__(24168);
// EXTERNAL MODULE: ../../libs/web-ui/src/styles/index.ts + 1 modules
var styles = __webpack_require__(1529);
;// CONCATENATED MODULE: ./components/create-account/create-account.styles.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useStyles = (0,styles/* createUseStyles */.QM)(function (theme) {
  var textFieldBaseStyles = {
    fontFamily: 'Roboto',
    fontWeight: '400',
    fontSize: theme.calcUnit(theme.spacing.s4),
    lineHeight: theme.calcUnit(theme.spacing.s6),
    padding: "".concat(theme.calcUnit(theme.spacing.s3), " ").concat(theme.calcUnit(10)),
    borderWidth: theme.calcUnit(1),
    borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
    marginTop: theme.calcUnit(theme.spacing.s2),
    opacity: 1,
    color: theme.colors.webTextField,
    borderColor: theme.colors.webBorder,
    width: '100%',
    '&:focus': {
      outline: 'none',
      paddingRight: theme.calcUnit(10)
    },
    '&::placeholder': {
      color: theme.colors.webTextFieldPlaceholder
    }
  };
  return {
    createAccountContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.calcUnit(theme.spacing.s5),
      height: '100vh'
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s1)
    },
    mainContainer: {
      width: theme.calcUnit(335)
    },
    heading: {
      fontFamily: 'Barlow',
      fontWeight: '700',
      fontSize: theme.calcUnit(theme.spacing.s6),
      lineHeight: theme.calcUnit(29),
      paddingTop: theme.calcUnit(theme.spacing.s3),
      margin: theme.calcUnit(0)
    },
    headingText: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: theme.calcUnit(theme.spacing.s4),
      lineHeight: theme.calcUnit(theme.spacing.s6),
      paddingTop: theme.calcUnit(theme.spacing.s2),
      margin: theme.calcUnit(0),
      color: theme.colors.webShortDescription
    },
    newsletterCheckboxContainer: {
      color: theme.colors.webFadedTextColor,
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.calcUnit(6),
      marginTop: theme.calcUnit(theme.spacing.s2)
    },
    newsletterCheckboxContainerSuccess: {
      color: theme.colors.webNewsletterSuccessText,
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.calcUnit(6),
      marginTop: theme.calcUnit(theme.spacing.s2)
    },
    newsletterCheckbox: {
      marginTop: theme.calcUnit(2),
      cursor: 'pointer'
    },
    newsletterCheckboxLabel: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: theme.calcUnit(theme.spacing.s3),
      lineHeight: theme.calcUnit(theme.spacing.s4),
      display: 'inline-block'
    },
    textFieldContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.calcUnit(theme.spacing.s4)
    },
    textFieldLabel: {
      fontFamily: 'Roboto',
      fontWeight: '400',
      fontSize: theme.calcUnit(14),
      lineHeight: theme.calcUnit(theme.spacing.s5)
    },
    mandatoryIndicator: {
      color: theme.colors.webErrorColor
    },
    email: _objectSpread({}, textFieldBaseStyles),
    password: function password(_ref) {
      var isSafari = _ref.isSafari;
      return _objectSpread(_objectSpread({}, textFieldBaseStyles), {}, {
        '&:focus': {
          paddingRight: isSafari ? theme.calcUnit(30) : theme.calcUnit(10),
          outline: 'none'
        }
      });
    },
    invalidEmail: _objectSpread(_objectSpread({}, textFieldBaseStyles), {}, {
      borderColor: "".concat(theme.colors.webErrorColor)
    }),
    createAccountButton: {
      marginTop: theme.calcUnit(theme.spacing.s6),
      '&:focus, &:hover': {
        background: theme.colors.webButtonHoverBackground
      }
    },
    optionLine: {
      border: "".concat(theme.calcUnit(1), " solid ").concat(theme.colors.webOptionBorder),
      width: '100%'
    },
    socialMediaOptionContainer: {
      display: 'grid',
      gridTemplateColumns: "1fr 1.5fr 1fr",
      marginTop: theme.calcUnit(theme.spacing.s6),
      alignItems: 'center',
      textAlign: 'center'
    },
    socialMediaOptionText: {
      fontFamily: 'Roboto',
      color: theme.colors.webOptionBorder,
      fontWeight: '400',
      fontSize: theme.calcUnit(theme.spacing.s3),
      lineHeight: theme.calcUnit(theme.spacing.s4),
      display: 'inline-block'
    },
    socialMediaButton: {
      display: 'grid',
      gridTemplateColumns: "1fr 1fr 1fr",
      marginTop: theme.calcUnit(theme.spacing.s6),
      justifyItems: 'center',
      alignItems: 'center',
      '& button': {
        height: theme.calcUnit(60),
        width: theme.calcUnit(60)
      },
      '& button:hover:not([disabled])': {
        border: "".concat(theme.calcUnit(2), " solid ").concat(theme.colors.webButtonHoverBackground)
      },
      '& button:focus:not([disabled])': {
        border: "".concat(theme.calcUnit(2), " solid ").concat(theme.colors.webButtonHoverBackground)
      }
    },
    signInLink: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.calcUnit(theme.spacing.s8),
      fontFamily: 'Roboto',
      color: theme.colors.webLinkText,
      fontWeight: '400',
      fontSize: theme.calcUnit(14),
      lineHeight: theme.calcUnit(theme.spacing.s4),
      '& button': {
        color: theme.colors.webActiveTextColor,
        fontWeight: '700',
        marginLeft: theme.calcUnit(theme.spacing.s1),
        textDecoration: 'underline',
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        outline: 'inherit'
      }
    },
    errorMessage: {
      display: 'flex',
      alignItems: 'center',
      fontFamily: 'Roboto',
      fontStyle: 'italic',
      color: theme.colors.webErrorColor,
      fontWeight: 400,
      fontSize: theme.calcUnit(theme.spacing.s3),
      lineHeight: theme.calcUnit(theme.spacing.s5),
      '& svg': {
        marginRight: theme.calcUnit(5)
      }
    },
    passwordIconContainer: {
      alignSelf: 'flex-end',
      position: 'absolute',
      cursor: 'pointer',
      background: 'none',
      margin: "".concat(theme.calcUnit(45), " ").concat(theme.calcUnit(theme.spacing.s1))
    }
  };
});
;// CONCATENATED MODULE: ./components/create-account/create-account-validation.ts

var formValidators = {
  validEmail: true,
  emailErrorMessage: '',
  validPassword: false,
  isValid: false
};
var FANTASY_SYNC = {
  MINIMUM_PASSWORD_SIZE: 8
};
var createAccountformValidators = function createAccountformValidators(email, password) {
  if (email === '') {
    formValidators.validEmail = false;
    formValidators.emailErrorMessage = 'Email is required.';
  } else if (!(0,utils_src/* isValidEmail */.vV)(email)) {
    formValidators.validEmail = false;
    formValidators.emailErrorMessage = 'Please enter a valid email address.';
  } else {
    formValidators.validEmail = true;
    formValidators.emailErrorMessage = '';
  }

  if (password === '' || password.length < FANTASY_SYNC.MINIMUM_PASSWORD_SIZE) {
    formValidators.validPassword = false;
  } else {
    formValidators.validPassword = true;
  }

  formValidators.isValid = formValidators.validEmail && formValidators.validPassword;
  return formValidators;
};
// EXTERNAL MODULE: ./constants/constants.ts
var constants = __webpack_require__(65218);
// EXTERNAL MODULE: ./utils/routes.ts
var routes = __webpack_require__(10576);
;// CONCATENATED MODULE: ./components/create-account-success/create-account-success.styles.ts

var create_account_success_styles_useStyles = (0,styles/* createUseStyles */.QM)(function (theme) {
  return {
    createAccountContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.calcUnit(theme.spacing.s5)
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s2)
    }
  };
});
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/navigation.js
var navigation = __webpack_require__(18310);
;// CONCATENATED MODULE: ./components/common/hooks/useRedirectTo.ts


var useRedirectTo = function useRedirectTo(_ref) {
  var router = _ref.router,
      onReady = _ref.onReady;

  var _useState = (0,react.useState)(''),
      redirectTo = _useState[0],
      setRedirectTo = _useState[1];

  var searchParams = (0,navigation.useSearchParams)();
  var routerIsReady = router.isReady;
  (0,react.useEffect)(function () {
    if (routerIsReady) {
      var redirectToParm = searchParams.get('redirect_to') || '';
      setRedirectTo(redirectToParm);

      if (onReady) {
        onReady(redirectToParm);
      }
    }
  }, [routerIsReady]);
  return {
    redirectTo: redirectTo
  };
};
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(260);
;// CONCATENATED MODULE: ./components/create-account-success/create-account-success.tsx










var CreateAccountSuccess = /*#__PURE__*/(0,react.memo)(function () {
  var router = (0,next_router.useRouter)();
  var styles = create_account_success_styles_useStyles();

  var _useAnalytics = (0,analytics_src/* useAnalytics */.z$)(),
      sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;

  var onRouterReady = function onRouterReady(redirectToParam) {
    router.push({
      query: {
        success: true,
        redirect_to: redirectToParam
      }
    }, undefined, {
      shallow: true
    });
  };

  var _useRedirectTo = useRedirectTo({
    router: router,
    onReady: onRouterReady
  }),
      redirectTo = _useRedirectTo.redirectTo;

  (0,react.useEffect)(function () {
    sendAnalyticsEvent('Account Created', {
      // TODO Need to pass accountMethod appropriately when social sign-in are implemented
      accountMethod: 'Email',
      subscriptionType: 'Free',
      source: 'Fantasy League Sync'
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: styles.createAccountContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(progress_pane_web/* ProgressPane */.Y, {
      state: schema_src.CurrentProgressState.SUCCESS,
      header: "Success! Account Created",
      message: "Please sign in to continue with your free account.",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
        className: styles.button,
        text: "Sign in",
        role: "button",
        variant: "Primary",
        type: "button",
        onClick: function onClick() {
          // We do not use router so it invokes the login check on merlin side
          window.location.href = "".concat(routes/* Routes.Login */.Z.Login, "?redirect_to=").concat(redirectTo);
        }
      })
    })
  });
});
;// CONCATENATED MODULE: ./components/create-account-error/create-account-error.styles.ts

var create_account_error_styles_useStyles = (0,styles/* createUseStyles */.QM)(function (theme) {
  return {
    createAccountContainer: {
      display: 'flex',
      justifyContent: 'center',
      padding: theme.calcUnit(theme.spacing.s5)
    },
    button: {
      marginTop: theme.calcUnit(theme.spacing.s1)
    }
  };
});
;// CONCATENATED MODULE: ./components/create-account-error/create-account-error.tsx







var CreateAccountError = function CreateAccountError(_ref) {
  var onClick = _ref.onClick;
  var router = (0,next_router.useRouter)();
  var styles = create_account_error_styles_useStyles();
  (0,react.useEffect)(function () {
    router.push({
      query: {
        success: false
      }
    }, undefined, {
      shallow: true
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: styles.createAccountContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(progress_pane_web/* ProgressPane */.Y, {
      state: schema_src.CurrentProgressState.ERROR,
      header: "Account Creation Failed",
      message: "We went for it on 4th and missed. Let's get another drive going and try again!",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
        className: styles.button,
        text: "TRY AGAIN",
        role: "button",
        variant: "Primary",
        type: "button",
        onClick: onClick
      })
    })
  });
};
;// CONCATENATED MODULE: ./components/create-account/create-account.tsx





function create_account_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function create_account_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? create_account_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : create_account_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















 // This is added because safari has a key icon, so in order to apply CSS to that, we need to define this



// TODO: Fix so we let the HTML form control the state
var CreateAccount = function CreateAccount() {
  var _useState = (0,react.useState)(formValidators),
      createAccountValidation = _useState[0],
      setCreateAccountValidation = _useState[1];

  var _useState2 = (0,react.useState)(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      isPasswordHidden = _useState3[0],
      setIsPasswordHidden = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isSafari = _useState4[0],
      setSafari = _useState4[1];

  var _useState5 = (0,react.useState)(''),
      password = _useState5[0],
      setPassword = _useState5[1];

  var _useState6 = (0,react.useState)(true),
      shouldSubscribeToNewsletter = _useState6[0],
      setShouldSubscribeToNewsletter = _useState6[1];

  var _useState7 = (0,react.useState)(false),
      ignoreError = _useState7[0],
      setIgnoreError = _useState7[1];

  var _useCreateUserAccount = (0,data_provider_src/* useCreateUserAccountMutation */.YyF)(),
      _useCreateUserAccount2 = (0,slicedToArray/* default */.Z)(_useCreateUserAccount, 2),
      createAccount = _useCreateUserAccount2[0],
      _useCreateUserAccount3 = _useCreateUserAccount2[1],
      error = _useCreateUserAccount3.error,
      loading = _useCreateUserAccount3.isLoading,
      success = _useCreateUserAccount3.isSuccess;

  var _useAnalytics = (0,analytics_src/* useAnalytics */.z$)(),
      sendAnalyticsEvent = _useAnalytics.sendAnalyticsEvent;

  var _useFeatureFlags = (0,src/* useFeatureFlags */.gV)(),
      getFeatureFlag = _useFeatureFlags.getFeatureFlag;

  var styles = useStyles({
    isSafari: isSafari
  });
  var router = (0,next_router.useRouter)();
  var recaptchaRef = (0,react.useRef)(null);

  var _useRedirectTo = useRedirectTo({
    router: router
  }),
      redirectTo = _useRedirectTo.redirectTo;

  (0,react.useEffect)(function () {
    var _window;

    setSafari(window && ((_window = window) === null || _window === void 0 ? void 0 : _window.safari) !== undefined);
  }, []);
  var shouldDisplayGoogleSignIn = getFeatureFlag('enable-google-social-sign-in', true);
  var shouldDisplayAppleSignIn = getFeatureFlag('enable-apple-social-sign-in', true);
  var shouldDisplayFacebookSignIn = getFeatureFlag('enable-facebook-sign-in', true);

  var processCreateAccount = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(recaptchaToken) {
      var createAccountForm;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createAccountForm = createAccountformValidators(email, password);

              if (createAccountForm.validEmail || createAccountForm.validPassword) {
                setCreateAccountValidation(function () {
                  return create_account_objectSpread({}, createAccountForm);
                });
                sendAnalyticsEvent('CTA Clicked', {
                  ctaName: 'Create Account',
                  ctaLocation: constants/* CTALocation.CREATE_FREE_ACCOUNT */.Pm.CREATE_FREE_ACCOUNT
                });
                createAccount({
                  email: email,
                  password: password,
                  shouldSubscribeToNewsletter: shouldSubscribeToNewsletter,
                  recaptchaToken: recaptchaToken
                });
                setIgnoreError(false);
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function processCreateAccount(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var processCreateAccountWithRecaptcha = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(e) {
      var token;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();

              if (!recaptchaRef.current) {
                _context2.next = 8;
                break;
              }

              _context2.next = 4;
              return recaptchaRef.current.executeAsync();

            case 4:
              token = _context2.sent;

              if (!token) {
                _context2.next = 8;
                break;
              }

              _context2.next = 8;
              return processCreateAccount(token);

            case 8:
              return _context2.abrupt("return", null);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function processCreateAccountWithRecaptcha(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleEmailChange = function handleEmailChange(e) {
    e.preventDefault();
    setEmail(e.target.value);
    var createAccountForm = createAccountformValidators(e.target.value, password);
    setCreateAccountValidation(function () {
      return create_account_objectSpread({}, createAccountForm);
    });
  };

  var handlePasswordChange = function handlePasswordChange(e) {
    e.preventDefault();
    var createAccountForm = createAccountformValidators(email, e.target.value);
    setCreateAccountValidation(function () {
      return create_account_objectSpread({}, createAccountForm);
    });
    setPassword(e.target.value);
  };

  var handleSubscribedChange = function handleSubscribedChange(e) {
    setShouldSubscribeToNewsletter(e.target.checked);
  };

  if (loading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: styles.createAccountContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(progress_pane_web/* ProgressPane */.Y, {
        state: schema_src.CurrentProgressState.IN_PROGRESS,
        header: "Creating Your Account.",
        message: "In the red zone going for it on 4th and 1."
      })
    });
  }

  if (error && !ignoreError) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAccountError, {
      onClick: function onClick() {
        setIgnoreError(true);
        router.push({
          query: {}
        }, undefined, {
          shallow: true
        });
      }
    });
  }

  if (success) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAccountSuccess, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: styles.createAccountContainer,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      onSubmit: processCreateAccountWithRecaptcha,
      className: styles.mainContainer,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
        className: styles.heading,
        children: "Create a FREE Account"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        className: styles.headingText,
        children: "Create an account to sync your fantasy league for FREE today."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: styles.textFieldContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: styles.textFieldLabel,
            children: ["Email ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: styles.mandatoryIndicator,
              children: " *"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "email",
            placeholder: "Email",
            name: "email",
            className: createAccountValidation.validEmail ? styles.email : styles.invalidEmail,
            onBlur: handleEmailChange
          }), !createAccountValidation.validEmail && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: styles.errorMessage,
            "data-testid": "error-message",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icon/* Icon */.J, {
              name: "field-error",
              group: utils_src/* SVGGroup.Icons */.OM.Icons,
              width: 12,
              height: 12
            }), createAccountValidation.emailErrorMessage]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: styles.textFieldContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            className: styles.textFieldLabel,
            children: ["Password ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: styles.mandatoryIndicator,
              children: " *"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: isPasswordHidden ? 'password' : 'text',
            placeholder: "Password",
            name: "password",
            className: styles.password,
            onChange: handlePasswordChange
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
            className: styles.passwordIconContainer,
            type: "button",
            onClick: function onClick() {
              return setIsPasswordHidden(!isPasswordHidden);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(icon/* Icon */.J, {
              name: isPasswordHidden ? 'password-hidden' : 'password-shown',
              group: utils_src/* SVGGroup.Icons */.OM.Icons,
              width: 16,
              height: 16
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: createAccountValidation.validPassword ? styles.newsletterCheckboxContainerSuccess : styles.newsletterCheckboxContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(icon/* Icon */.J, {
            name: createAccountValidation.validPassword ? 'circle-checkmark-green' : 'circle-checkmark-grey',
            group: utils_src/* SVGGroup.Icons */.OM.Icons,
            height: 16,
            width: 16
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: styles.newsletterCheckboxLabel,
            htmlFor: "newsletterCheckbox",
            children: "Password must be min 8 characters"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: styles.newsletterCheckboxContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "checkbox",
            className: styles.newsletterCheckbox,
            id: "newsletterCheckbox",
            onChange: handleSubscribedChange,
            defaultChecked: true
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            className: styles.newsletterCheckboxLabel,
            htmlFor: "newsletterCheckbox",
            children: "Sign me up to receive exclusive promotions, news, and other features from PFF via email"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          className: styles.createAccountButton,
          text: "Create account",
          role: "button",
          variant: "Primary",
          type: "submit",
          disabled: !createAccountValidation.isValid
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: styles.socialMediaOptionContainer,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
          className: styles.optionLine
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: styles.socialMediaOptionText,
          children: "Or continue with"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("hr", {
          className: styles.optionLine
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: styles.socialMediaButton,
        children: [shouldDisplayAppleSignIn && /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          variant: "SocialMedia",
          onClick: lodash.noop,
          "data-testid": "apple-sign",
          size: "sm",
          iconWidth: "24",
          iconHeight: "28",
          iconName: "apple-blue",
          text: "Apple"
        }), shouldDisplayGoogleSignIn && /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          variant: "SocialMedia",
          onClick: lodash.noop,
          "data-testid": "google-sign",
          size: "sm",
          iconWidth: "24",
          iconHeight: "28",
          iconName: "google-blue",
          text: "Google"
        }), shouldDisplayFacebookSignIn && /*#__PURE__*/(0,jsx_runtime.jsx)(button_button/* Button */.z, {
          variant: "SocialMedia",
          "data-testid": "facebook-sign",
          onClick: lodash.noop,
          size: "sm",
          iconWidth: "24",
          iconHeight: "28",
          iconName: "facebook-blue",
          text: "Facebook"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: styles.signInLink,
        children: ["Already have an account?", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          onClick: function onClick() {
            window.location.href = "".concat(routes/* Routes.Login */.Z.Login, "?redirect_to=").concat(redirectTo);
          },
          children: "Sign In"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
        ref: recaptchaRef,
        size: "invisible",
        sitekey: "6LfV2KwaAAAAAHDxwLeHzKTfpsvobH0h5gmMSNmr"
      })]
    })
  });
};
;// CONCATENATED MODULE: ./pages/create-account/index.tsx



function Index() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CreateAccount, {});
}

/***/ }),

/***/ 22341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-account",
      function () {
        return __webpack_require__(99352);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [928,479,388,637,774,888,179], function() { return __webpack_exec__(22341); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);